module.exports = __webpack_public_path__ + "img/medal_one_white.31084e07.png";